<div class="page">
    <div class="header">
        <h2>{{ 'admin.tool-history.status-history-table.title' | translate }}</h2>
        <app-report-download-form [tableConfig]="requestConfig"
                                  [isLoading]="isLoadingDownload"
                                  [appendTo]="'body'"
                                  (filterChange)="onFilterChange(tableFilters, $event)"
                                  (reportDownload)="onStatusHistoryDownload($event)">
        </app-report-download-form>
    </div>
    <div class="content">
        <app-status-history-table [toolStatusHistory]="toolStatusHistory"
                                  [isLoading]="isLoadingToolStatusHistory"
                                  [tableConfig]="tableConfig"
                                  [hasTitle]="false"
                                  [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                  (sortChange)="onSortChange($event)"
                                  (pageChange)="onPageChange($event)"
                                  (filterChange)="onFilterChange($event.filters, reportFilters)">
        </app-status-history-table>
    </div>
</div>
